import {Modal, Input, Form, Button, message, Cascader} from 'antd'
import {useEffect, useMemo, useState} from "react";
import {cloneDeep, isEmpty} from "lodash-es";
import {
  goodsSaleCategorySave,
  goodsSaleCategoryUpdateById
} from "@/services/goods.ts";
import {deleteObjNodeById, trimStr} from "@/utils/data.ts";

const SellModal = props => {
  const { addOrEditModalOpen: open, onClose, fn, record } = props
  const [ form ] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    form.resetFields()
    if(open && !isEmpty(record)) {
      const cateIdPath = record.cateIdPath?.split('>')
      const parentIdPath = cateIdPath?.slice(1, cateIdPath.length - 1);
      form.setFieldsValue({...record, parentId: parentIdPath})
    }
  }, [open]);

  const newTreeData = useMemo(() => {
    const data = cloneDeep(props.cateTreeList)
    if(record?.id && !isEmpty(data)){
      deleteObjNodeById(data, record.parentId, record.id)
    }
    return data;
  },[props.cateTreeList, record.id])

  const save = () => {
    form.validateFields().then((values) => {
      setBtnLoading(true)
      const apiUrl = values.id ? goodsSaleCategoryUpdateById : goodsSaleCategorySave
      const parentId = values.parentId ? (values.parentId[values.parentId.length - 1] || 0) :  values.id ? '' : record.parentId
      apiUrl({...values, parentId}).then(res=>{
        message.success(res?.message || '操作成功');
        onClose?.()
        fn?.()
      }).finally(() => setBtnLoading(false))
    });
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={500}
      title={ record.id ? "编辑分类" : "新增分类" }
      footer={[
        <Button loading={btnLoading} key="cancel" onClick={onClose}>
          取消
        </Button>,
        <Button loading={btnLoading} key="save" type="primary" onClick={save}>
          保存
        </Button>,
      ]}
    >
      <Form
        style={{ padding: "10px 0" }}
        form={form}
        layout={'vertical'}
        name="paySetInfo"
        labelCol={{
          span: 6,
        }}
      >
        <Form.Item hidden name={'id'}><Input/></Form.Item>
            <Form.Item
              name="parentId"
              label="父级分类"
              hidden={!record.id}
            >
              <Cascader changeOnSelect
                        expandTrigger={'hover'}
                        displayRender={(labels: string[]) => labels[labels.length - 1]}
                        options={newTreeData}
                        fieldNames={{ value: 'id'}}
                        placeholder={'请选择父级分类'}
              />
            </Form.Item>
        <Form.Item
          name="cateName"
          label="分类名称"
          rules={[
            {
              required: true,
              message: '分类名称不能为空',
            },
          ]}
        >
          <Input maxLength={15} placeholder={'请输入分类名称'} showCount  onChange={(v:any):void => {
            form.setFieldValue('cateName', trimStr(v.target.value))
          }} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SellModal
